import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DatasetService } from 'app/main/services/dataset.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from 'app/main/services/app.service';
import { BaseLanguageLoaderComponent } from '../base-language-loader.component';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss']
})
export class HomeComponent extends BaseLanguageLoaderComponent implements OnInit, OnDestroy{

	_data: any;
	_isLoading: boolean;

	constructor(
		public appService: AppService,
		public translate: TranslateService,
		private datasetService: DatasetService) {
			super(appService, translate);
		}

	ngOnInit(): void {
		super.ngOnInit();
	}

	ngOnDestroy(): void{
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}

	_load(): void{
		/*this._isLoading = true;
		this.datasetService.get<any>('/products/list')
		.pipe(takeUntil(this._unsubscribeAll))
		.subscribe({
			next: response => {
				this._data = response;
				this._isLoading = false;
			},
			error: response => {
				this._isLoading = false;
			}
		});*/
	}
}
